import { render, staticRenderFns } from "./Flota.vue?vue&type=template&id=22e8e717&scoped=true"
import script from "./Flota.vue?vue&type=script&lang=js"
export * from "./Flota.vue?vue&type=script&lang=js"
import style0 from "./Flota.vue?vue&type=style&index=0&id=22e8e717&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e8e717",
  null
  
)

export default component.exports